"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var liteEvent_1 = require("./liteEvent");
var PlanChangedEvent = (function (_super) {
    __extends(PlanChangedEvent, _super);
    function PlanChangedEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlanChangedEvent.prototype.trigger = function (placements) {
        _super.prototype.fire.call(this, placements);
    };
    return PlanChangedEvent;
}(liteEvent_1.LiteEvent));
exports.PlanChangedEvent = PlanChangedEvent;
//# sourceMappingURL=PlanChangedEvent.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/PlanChangedEvent.js
// module id = 59
// module chunks = 0